import { yupResolver } from '@hookform/resolvers/yup'
import { useTranslation } from 'react-i18next'
import * as yup from 'yup'

export const useCouponValidationSchema = () => {
	const { t } = useTranslation()

	const couponValidationSchema = yup.object({
		code: yup.string().required(t('Code is required')),
		price_discount_value: yup
			.number()
			.required(t('Value is required'))
			.min(0)
			.when('price_discount_is_percentage', ([priceDiscountIsPercentage], schema) => {
				return priceDiscountIsPercentage ? schema.max(100) : schema
			})
			.typeError('Value is required'),
		price_discount_is_percentage: yup.bool().required(),
		is_active: yup.bool().required(),
		// empty input = null = unlimited
		max_uses: yup
			.number()
			.transform((value, original) => (original === '' || original == null ? null : value))
			.nullable()
			.integer(t('Max uses must be a whole number'))
			.min(1, t('Max uses must be at least 1')),
		valid_from: yup.date().required(t('Valid from is required')),
		valid_until: yup
			.date()
			.required(t('Valid until is required'))
			.min(yup.ref('valid_from'), t('Valid until must be on or after valid from')),
		booking_window_start: yup.date().required(t('Start date is required')),
		booking_window_end: yup
			.date()
			.required(t('End date is required'))
			.min(yup.ref('booking_window_start'), t('End date must be after start date'))
	})

	return yupResolver(couponValidationSchema)
}
